module.exports = __webpack_public_path__ + "img/isometric-lego.063fb4b5.svg";